import {Box, Button, Typography, Modal } from "@mui/material"
import { Products } from "./Products"
import {useState } from "react"
import { Setup } from "./Setup"
import { Summary } from "./Summary"
import { Logo } from "../../../../../core/global/Icons"
import { CstmSnackBar } from "../../../../../core/global/forms/CstmSnackBar"
import { domain, env } from "../../../../../core/Env"
import cafgu from "../../../../../assets/images/core/cafgu.svg"
import pos from "../../../../../assets/images/logos/pos.png"
import AddBusinessIcon from '@mui/icons-material/AddBusiness';

export const Index = ()=>{

    const [info, setInfo] = useState({
        branch_name: ""
    })
    const [products, setProducts] = useState([])
    const [orderList, setOrderList] = useState([])
    const [snackBarLoader, setSnackBarLoader] = useState({snackbar:false, msg:'', type:''})
    const [setOrder] = useState([])
    const [open, setOpen] = useState(false)


    const tool_id =  process.env.REACT_APP_TID_BIZ;

    const regHandler = () => {
        let subscription = (env() === 'dev' ? 'c3Vic2NyaXB0aW9uXzY5NQ==' : (env() === 'sb' ? 'c3Vic2NyaXB0aW9uXzQ2NQ==' : 'c3Vic2NyaXB0aW9uXzM2NA==')) 
        window.location.href = `${domain('mp').url}/subscription/checkout/rqx?tid=${window.btoa(`tool_${tool_id}`)}&callback=${env()}&platform=business&subscription=${subscription}&ref=unauth&auth_type=registration`;
    }
    
    return (
        <Box sx={{p: 5, height: "100%"}}>
            <Box sx={{display: "flex", height: "100%", spacing: 2, gap: 2}}>
                <Box sx={{width: "50%", height:"100%", bgcolor: "#fff", borderRadius: 8, p: 3}}>
                    <Box sx={{p: 3, borderRadius: 3, background: ` linear-gradient( 180deg, rgba(141, 255, 175, 0.06) 0%, rgba(0, 63, 46, 0.10) 100%)`, height: "100%", display: "flex", flexDirection: "column", gap: 2}}>
                        <Box sx={{display: "flex", gap: 2, justifyContent: "space-between", alignItems: "center"}}>
                            <Box sx={{display: "flex", gap: 2}}>
                                <Logo size={24} />
                                <Box fontSize={16} fontWeight={600} lineHeight="24px" color="primary.main">POS</Box>
                            </Box>
                            <Button onClick={regHandler} sx={{display: "flex", gap: 2, bgcolor:'#c0ffd0ff', px: 2 , ':hover': {bgcolor: "#c0ffd0ff"}, alignItems: "center", borderRadius: 8}}>
                                <Box component="img" src={cafgu} sx={{borderRadius: 4, width: 50, margin: "auto"}}/>
                                <Box sx={{fontWeight: 600, color: "primary.main"}}>
                                    Activate Full POS Features Today!
                                </Box>
                            </Button>
                        </Box>
                        
                        <Box sx={{height: "100%"}}>
                            {products.length > 0 ?
                                <Products products={products} setOrderList={setOrderList} orderList={orderList}/>
                            :

                                <Box width="100%" height="100%" display="flex" justifyContent="center" alignItems="center">
                                    <Box textAlign="center">
                                        <AddBusinessIcon sx={{color: "primary.main", fontSize: 100}}/>
                                        <Box color="#011104" fontSize={14} >Add a product first</Box>
                                    </Box>
                                </Box>

                            }
                        </Box>
                    </Box>
                </Box>
                <Box sx={{width: "25%"}}>
                    <Box sx={{height:"100%", bgcolor: "#fff", borderRadius: 8, p: 3}}>
                        <Summary orderList={orderList} setOrderList={setOrderList} setOrder={setOrder} snackBarLoader={snackBarLoader} setSnackBarLoader={setSnackBarLoader} />
                    </Box>
                </Box>
                <Box sx={{width: "25%"}}>
                    <Box sx={{height:"100%", bgcolor: "#fff", borderRadius: 8}}>
                        <Setup setOpen={setOpen} snackBarLoader={snackBarLoader} setSnackBarLoader={setSnackBarLoader} products={products} setProducts={setProducts} setInfo={setInfo} info={info}/>
                    </Box>
                </Box>
            </Box>
            {snackBarLoader.snackbar && (
                <CstmSnackBar value={snackBarLoader} setter={setSnackBarLoader} msg={snackBarLoader.msg} type={snackBarLoader.type} /> 
            )}
        <Modal open={open} onClose={()=>{setOpen(false)}} sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
            <Box sx={{ bgcolor: "#fff", width: { xs: "90%", md: "30%" }, borderRadius: 4, p: 4, textAlign: "center", boxShadow: 24 }}>
                <Box sx={{display: "flex", gap: 4, justifyContent: "center"}}>
                    <Box component="img" src={cafgu} sx={{ borderRadius: 4, width: 100, mb: 2 }} />
                    <Box component="img" src={pos} sx={{ borderRadius: 4, width: 100, mb: 2 }} />
                </Box>
                <Typography variant="h5" fontWeight="bold" mb={1}>Unlock Full POS Access</Typography>
                <Typography variant="body1" color="text.secondary" mb={3}>Register now to manage sales, view reports, and run your business smarter.</Typography>
                <Button variant="contained" size="large" sx={{ borderRadius: 3, px: 4, py: 1.2, textTransform: "none", fontWeight: "bold" }} onClick={regHandler}>Register to Get Full Access</Button>
            </Box>
        </Modal>

        </Box>
    )
}   